/* istanbul ignore file */
import { makeFragmentData } from '@packages/gql/generated/shopping';
import type { SimilarRecoFragmentFragment } from '@packages/gql/generated/shopping/graphql';
import { SimilarRecoFragmentFragmentDoc } from '@packages/gql/generated/shopping/graphql';

export const similarProductsDataMock: SimilarRecoFragmentFragment = {
  hasSeries: true,
  promotion: '79',
  orderNumber: '96692022',
};

export function getSimilarProductsFragmentedData(data?: SimilarRecoFragmentFragment) {
  return makeFragmentData(data || similarProductsDataMock, SimilarRecoFragmentFragmentDoc);
}
